export default __webpack_public_path__ + "static/media/logo-tts-en-v3.e9f652ff.svg";